// extracted by mini-css-extract-plugin
export default {"errorText":"styles_errorText__tOOmy"};